import NewAppointment from './components/NewAppointment';
import AppointmentCount from '../Appointments/Counting';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import DateCheck from 'Utils/Helpers/DateCheck';
import Dashboard from './components/Dashboard';

export default function DashboardIndex() {
    const { current, dateSearch, weeklyLimit, appointments } = useSelector((state) => ({
        current: state.staff.current,
        dateSearch: state.setting.dateSearch,
        weeklyLimit: state.setting.weeklyLimit,
        appointments: state.appointments.appointments,
    }));
    const [dayLimit, setDayLimit] = useState(0);
    const [preDate, setPreDate] = useState(false);

    useEffect(() => {
        if(dateSearch.date) {
            setPreDate(DateCheck(dateSearch.date))
        }
    },[dateSearch.date])

    useEffect(() => {
        if(dateSearch.dow !== '' && weeklyLimit)
            setDayLimit(weeklyLimit.find(i => i.id === dateSearch.dow).count)
    }, [dateSearch.dow, weeklyLimit])

    return (
        <>
            <AppointmentCount />
            <Dashboard />
            {
                ( current[0][2] && appointments && preDate && dayLimit !== 0 && appointments.filter(i => i.lastStatus !== 5).length < dayLimit)
                && <NewAppointment />
            }
        </>
    );
}